
export default [
    {
        path: 'relatorio-prescricao-interna',
        component: () => import(
            /* webpackChunkName: 'relatorio-prescricao-interna' */
            '@/views/pronto-atendimento/relatorio-prescricao-interna/Index'
        ),
        redirect: 'relatorio-prescricao-interna/index',
        children: [
            {
                name: 'relatorio-prescricao-interna-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'relatorio-prescricao-interna' */
                    '@/views/pronto-atendimento/relatorio-prescricao-interna/List.vue'
                ),
            },
        ],
    },
]